define(['jquery',
        'core/urls',
        'core/utilities',
        'components/datatable',
        'core/browser-storage',
        'components/fake-progress',
        'bootstrap-toggle',
        'bootstrap-confirmation2'],
    function($, urls, utilities, dataTable, browser_storage, FakeProgress) {

        let nodes = {
            rulesHeader: document.querySelector(".page-header.created-rules"),
            filterSettings: document.querySelector(".settings-panel.filter-settings"),
            filterSettingsToggle: document.querySelector(".settings-toggle-wrap"),
            filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
            filterToggles: document.querySelectorAll(".filter-settings .mini-toggle input"),
            filterSaveButton: document.querySelector(".filter-settings .save-changes")
        }

        let filterParams = {
            "csat": true,
            "nps": true,
            "project": true,
            "enabled": false,
        }

        let table;

        let loaderElement = document.querySelector(".marketing-loader");

        let editedRule = browser_storage.getItem("automation-edited");

        let progressBar = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        let togglesHaveBeenEdited = false;

        let previousIDs = browser_storage.getItem("automation-ids") ? browser_storage.getItem("automation-ids").split(",") : [];

        let createTableEvents = () => {
            
            let allToggles = document.querySelectorAll(".automation-enable-checkbox");

            let clickEvent = (event) => {
                togglesHaveBeenEdited = true;
                    
                loaderElement.classList.remove("disabled");
                progressBar.startLoading(5);

                // show loader for 1 second to prevent spamming of toggles
                setTimeout(() => {
                    loaderElement.classList.add("disabled");
                    progressBar.loadFinish();
                }, 1000);

                let checkbox = event.currentTarget;
                console.log(checkbox);
                let ruleId = checkbox.getAttribute("data-rule-id");
                
                let newState = checkbox.checked;

                console.log("     new state: ", newState);

                if(newState) {
                    event.currentTarget.classList.remove("off");
                    event.currentTarget.classList.add("btn-success");
                } else {
                    event.currentTarget.classList.add("off");
                    event.currentTarget.classList.remove("btn-success");
                }
                
                let endpoint = urls['automation:toggle-rule'](ruleId, newState ? 'enable' : 'disable');
                $.ajax(endpoint, {type: 'POST'});
            }
            
            allToggles.forEach(toggleWrap => {
                toggleWrap.removeEventListener("click", clickEvent);
                toggleWrap.addEventListener("click", clickEvent);
            });
        };

        let createSortEvents = () => {

            $("#automationRules").on('order.dt', function () {
                // refresh table data if toggles have been edited, and user is
                // sorting by "status" (column 4)

                var order = table.order();

                if(order[0][0] === 4 && togglesHaveBeenEdited) {

                    dataTable.reloadData("#automationRules", () => {
                        setTimeout(() => {
                            createTableEvents();
                            createDeleteEvents();
                            createSortEvents();
                        }, 1000)
                    });

                    togglesHaveBeenEdited = false;
                }
            } );
        }

        let createDeleteEvents = () => {
            // delete rules
            utilities.confirmationTooltip("delete-rule", (data) => {
                let ruleId = data.id;
                let endpoint = urls['automation:edit-rule'](ruleId);
                $.ajax(endpoint, {
                    type: 'DELETE', success: function () {
                        
                        dataTable.reloadData("#automationRules", () => {
                            createTableEvents();
                            createSortEvents();
                            createDeleteEvents();
                        });
                    }
                });
            })
        }

        let filterEventListeners = () => {
            nodes.filterSettingsToggle.addEventListener("click", () => {
                nodes.filterSettingsToggle.classList.contains("active") ? nodes.filterSettingsToggle.classList.remove("active") : nodes.filterSettingsToggle.classList.add("active");
                
                if(nodes.filterSettings.classList.contains("hide")) {
                    nodes.filterSettings.classList.remove("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Hide Filters";
                } else {
                    nodes.filterSettings.classList.add("hide");
                    nodes.filterSettingsToggleLabel.innerText = "Show Filters";
                }
            })

            nodes.filterToggles.forEach((toggle) => {
                toggle.addEventListener("change", (event) => {
                    let type = event.target.dataset.propertyType;
                    filterParams[type] = event.target.checked;
                })
            })


            nodes.filterSaveButton.addEventListener("click", () => {
                table.draw();
                nodes.rulesHeader.click();
                nodes.filterSettingsToggle.click();
            })
            
        }

        return {
            init: function () {

                loaderElement.classList.remove("disabled");

                progressBar.startLoading(5);

                dataTable.create('#automationRules', {
                    columns: [
                        {
                            title: 'Trigger',
                            className: 'column-trigger',
                            data: 'trigger.type',
                            width: "80px",
                            render: {
                                display: function(data) {
                                    let icon;    
                                    let desc;
                                    
                                    if(data === "REACTION_RECEIVED") { icon = "plus"; desc='New CSAT review received' }
                                    if(data === "TAG_ADDED") { icon = "tag"; desc='Tag added to review' }
                                    if(data === "SCORE_RECEIVED") { icon = "dashboard"; desc = "New NPS score received"; }
                                    if(data === "STATUS_CHANGED") { icon = "adjust-alt"; desc = "Status of review has changed"; }
                                    if(data === "RATING") { icon = "plus"; desc = "New Project Survey Response Received"; }
                                    
                                    return `<div class="tooltip-wrap">
                                                <span class="glyphicons glyphicons-${icon}"></span>
                                                <div class="sb-tooltip"> ${desc} </div>
                                            </div>`
                                }
                            }
                        },
                        {
                            title: 'Action',
                            className: 'column-action',
                            data: 'action.type',
                            width: "80px",
                            render: {
                                display: function(data, type, full) {
                                    return `<div class="tooltip-wrap">
                                                <span class="glyphicons ${full.action.icon}"></span>
                                                <div class="sb-tooltip"> ${full.action.description} </div>
                                            </div>`
                                }
                            }
                        },
                        {
                            title: 'Description',
                            className: 'column-name',
                            data: 'name',
                            render: {
                                display: function(data, type, full) {
                                    let el = document.createElement('div');
                                    el.className = 'rule-title';
                                    el.innerText = data;
                                    let markup = `${el.outerHTML}
                                                    <div class="rule-desc">${full.as_sentence}</div>`
                                    return markup;
                                }
                            }
                        },
                        {
                            title: 'Type',
                            className: 'column-type',
                            data: 'type',
                            width: "80px",
                            render: {
                                display: function(data) {
                                    let value = data === "project" ? "Project Survey" : data.toUpperCase();
                                    return `<strong>${value}</strong>`;
                                }
                            }
                        },
                        {
                            title: 'Enabled',
                            className: 'column-status',
                            data: 'is_active',
                            width: "80px",
                            render: {
                                display: function(data, type, full,) {
                                    let mainWrapper = document.querySelector("#automation-rules-list");
                                    let accountDisabled = mainWrapper.getAttribute("data-account-active") === 'True' ? false : true;
                                    let markup = `
                                        <div class="mini-toggle toggle-wrap ${accountDisabled ? "disabled" : ""}">
                                            <input ${data ? "checked" : ""} id="automation-toggle-${full.id}" data-rule-id=${full.id} class="automation-enable-checkbox" type="checkbox" data-toggle="toggle">
                                            <label for="automation-toggle-${full.id}">Show hidden only</label>
                                        </div>`
                                    return markup;
                                }
                            }
                        },
                        {
                            title: '',
                            className: 'column-actions',
                            data: 'is_active',
                            orderable: false,
                            width: "100px",
                            render: {
                                display: function(data, type, full,) {
                                    let mainWrapper = document.querySelector("#automation-rules-list");
                                    let accountDisabled = mainWrapper.getAttribute("data-account-active") === 'True' ? false : true;
                                    let markup = `
                                        <a href="/automation/${full.id}/" role="button" class="btn btn-primary automation-rule-item-action ${accountDisabled ? "disabled" : ""}" style="margin-left: 10px">
                                            <span class="glyphicons glyphicons-pencil"></span>
                                        </a>
                                        <div class="tooltip-wrap delete-rule btn btn-danger">
                                            <a class="icon remove glyphicons glyphicons-remove-sign"></a>
                                            <div class="sb-tooltip action">
                                                Delete rule
                                            </div>
                                            <div class="sb-tooltip confirmation">
                                                Really delete rule?
                                                <div class="options">
                                                    <span class="confirm" data-id="${full.id}">Yes</span>
                                                    <span class="deny" data-id="${full.id}">No</span>
                                                </div>
                                            </div>
                                        </div>`
                                    return markup;
                                }
                            }
                        },
                    ],
                    columnDefs: [
                        {
                            orderSequence: ['desc', 'asc'],
                            targets: [2]
                        }
                    ],
                    ajax: {
                        url: urls['automation:rules-data'](),
                        dataSrc: 'rules',
                        error: function (jqXHR, textStatus, errorThrown) {
                            if (jqXHR.status == 302) {
                                // server requested a page reload
                                window.location.reload();
                            } else if(jqXHR.status == 403) {
                                 window.location.href = urls['account:auth-login']() + '?next=' + window.location.pathname;
                            } else {
                                $('.dataTables_empty').text('Error loading data. Auto-retrying in less than 5 minutes...');
                            }
                        }
                    },
                    buttons: [],
                    paging: false,
                    info: false,
                    searching: true,
                    language: {
                        search: "",
                        searchPlaceholder: "Search",
                    },
                    createdRow: function (row, data) {
                        $(row).attr('data-rule-id', data.id);
                    },
                    initComplete: function() {
                        let api = this.api();
                        let data =  api.ajax.json();

                        progressBar.loadFinish();
                        loaderElement.classList.add("disabled");

                        let highlightRule = (id) => {
                            let highlightRow = document.querySelector(`[data-rule-id="${id}"]`);

                            if(!highlightRow) return;

                            highlightRow.classList.add("highlight");
                            highlightRow.scrollIntoView();

                            setTimeout(() => {
                                highlightRow.classList.remove("highlight");                                
                            }, 2000);
                        }

                        if(data) {
                            if(data.csat_admin) {
                                document.querySelectorAll(".add-csat-rule").forEach(node => {
                                    node.classList.remove("hide");
                                })
                            }
    
                            if(data.nps_admin) {
                                document.querySelectorAll(".add-nps-rule").forEach(node => {
                                    node.classList.remove("hide");
                                })
                            }

                            if(data.projects_admin) {
                                document.querySelectorAll(".add-project-rule").forEach(node => {
                                    node.classList.remove("hide");
                                })
                            }

                            if(!data.rules.length) {
                                document.querySelector(".dataTables_empty").classList.add("hide");
                                document.querySelector(".automation-rule-empty-message").classList.remove("hide");
                            } else {
                                let updatedIDs = [];

                                data.rules.forEach(rule => {
                                    updatedIDs.push(rule.id);
                                })

                                browser_storage.setItem("automation-ids", updatedIDs);

                                if(previousIDs.length !== updatedIDs.length) {
                                    let newID = updatedIDs.filter(x => !previousIDs.includes(x + ""))

                                    highlightRule(newID);
                                }
                            }
                        }

                        table = $('#automationRules').DataTable();

                        if(editedRule) {
                            highlightRule(editedRule);

                            browser_storage.removeItem("automation-edited");
                        }
                       
                        createTableEvents();
                        createSortEvents();
                        createDeleteEvents();                        
                    }
                });

                $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
                    let returnValue = false;
    
                    // rule type filters
                    if(data[3] === 'csat' && filterParams["csat"] === true) returnValue = true;
                    if(data[3] === 'nps' && filterParams["nps"] === true) returnValue = true;
                    if(data[3] === 'project' && filterParams["project"] === true) returnValue = true;
                    
                    // enabled / disabled filter
                    // if(data[4] === 'false' && filterParams["enabled"] === true) returnValue = false;
    
                    return returnValue;
                });

                filterEventListeners();                 
            }
        }
    }
);
